import { useMemo } from 'react';
import { LifecycleState } from 'api/GraphQL/queries/getVehicleSummaries';

type UseButtonTextParams = {
  lifecycleState: LifecycleState;
  isOfferAccepted: boolean;
};

/**
 * Custom hook to determine the appropriate button text based on lifecycle state and offer acceptance.
 */
export const useButtonText = ({ lifecycleState, isOfferAccepted }: UseButtonTextParams): string =>
  useMemo(() => {
    switch (lifecycleState) {
      case LifecycleState.Active:
        return isOfferAccepted ? 'Continue' : 'View Your Offer';
      case LifecycleState.Scheduled:
        return 'View Appointment';
      case LifecycleState.AppliedToPurchase:
        return 'View Trade Details';
      case LifecycleState.Complete:
        return 'View Sale Details';
      case LifecycleState.Expired:
        return 'Refresh Your Offer';
      case LifecycleState.NeedsManualAppraisal:
      case LifecycleState.Rejected:
        return 'View details';
      default:
        return 'View details';
    }
  }, [lifecycleState, isOfferAccepted]);
